module.exports = __webpack_public_path__ + "images/thumb-6e7d31b28679ba10e27c2c20aede4a4e.jpg";